import type { ColumnPin } from "@common/types/views/views";
import { ColumnItem } from "./ColumnItem";
import type { ColumnData } from "./columnSettingsUtils";

interface ColumnSectionProps {
    readonly columns: ColumnData[];
    readonly activeId: string | null;
    readonly onToggleVisibility: (columnId: string) => void;
    /** With it, each row gets the pin menu. */
    readonly onPin?: (columnId: string, pin: ColumnPin | undefined) => void;
}

/** One pin group of the shown, draggable rows, as siblings of the section's other rows. */
export const ColumnSection = ({
    columns,
    activeId,
    onToggleVisibility,
    onPin,
}: ColumnSectionProps) =>
    columns.map((column) => (
        <ColumnItem
            key={column.id}
            id={column.id}
            name={column.name}
            hint={column.hint}
            isVisible
            isPinned={column.options?.pin}
            immutable={column.immutable}
            required={column.required}
            isDraggable={!column.immutable}
            isDragInProgress={activeId !== null}
            onToggleVisibility={() => onToggleVisibility(column.id)}
            onPin={onPin && ((pin) => onPin(column.id, pin))}
        />
    ));
